import styled from 'styled-components/macro'

export const BoxShadow = styled.div`
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.13);
`

export default BoxShadow
